import { PlusOutlined } from '@ant-design/icons';
import { Modal, Upload } from 'antd';
import type { RcFile, UploadProps } from 'antd/es/upload';
import type { UploadFile } from 'antd/es/upload/interface';
import { FC, useEffect, useState } from 'react';
import { UploadImagesProps } from './interface';
import { useAppSelector } from 'store';
import {backendUrl} from 'config'


const getBase64 = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = error => reject(error);
    });

type AnyItem = { uid?: string; id?: string; url?: string; [key: string]: unknown };

const normalizeToUploadFile = (items: AnyItem[]): UploadFile[] =>
    items.map((item, i) => {
        if (item.uid) return item as unknown as UploadFile;
        return {
            uid: item.id ?? String(-i - 1),
            name: item.url?.split('/').pop() ?? 'image',
            status: 'done' as const,
            url: item.url,
        } as UploadFile;
    });

const UploadImages: FC<UploadImagesProps> = ({ maximumUploadItems, disabled, isEdit, value, allowFileExtensions, onChange }) => {
    const accessTokenKey = useAppSelector(state => state.auth.accessToken)

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [fileList, setFileList] = useState<UploadFile[]>(
        value ? normalizeToUploadFile(value as unknown as AnyItem[]) : []
    );

    useEffect(() => {
        if (value !== undefined) {
            setFileList(normalizeToUploadFile(value as unknown as AnyItem[]));
        }
    }, [value]);

    const handleCancel = () => setPreviewOpen(false);

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
    };

    const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
        setFileList(newFileList);

        // ไม่ส่ง onChange ขณะที่ไฟล์กำลังอัพโหลดอยู่
        // เพื่อป้องกัน Form ส่ง value กลับมาทับ fileList ที่กำลัง upload
        const isUploading = newFileList.some(f => f.status === 'uploading');
        if (isUploading) return;

        const newFileListUrl = newFileList.map((item) => {
            if (item.response) {
                return {
                    url: item.response?.url,
                    id: item.response?.id,
                }
            }
            return {
                id: item.uid,
                url: item.url,
            }
        });
        onChange?.(newFileListUrl);
    }

    const onBeforeUpload: UploadProps['beforeUpload'] = (file) => {
        const fileName = file.name.split('.');
        const fileExtension = fileName[fileName.length - 1];
        const newFileName = `${Date.now()}.${fileExtension}`;
        const newFile = new File([file], newFileName, { type: file.type });

        return newFile;
    };
       

    const uploadButton = (
        <div>
            <PlusOutlined style={{ color: "#417B97" }} />
            <div style={{ marginTop: 8, color: "#417B97" }}>เพิ่มรูปภาพ</div>
        </div>
    );
    return (
        <>
            <Upload
                disabled={disabled}
                action={`${backendUrl}images/upload?type=product`}
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                maxCount={maximumUploadItems}
                accept={allowFileExtensions}
                onRemove={(file) => {
                    const newFileList = fileList?.filter((item) => item.uid !== file.uid) ?? [];
                    setFileList(newFileList);
                    const newImageList = newFileList.map(item => ({
                        id: item.uid,
                        url: item.url,
                    }));
                    onChange?.(newImageList);
                }}
                headers={{
                    Authorization: `Bearer ${accessTokenKey}`,
                }}
                beforeUpload={onBeforeUpload}
            >
                { fileList && fileList.length >= maximumUploadItems ? null : uploadButton}
            </Upload>
            <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
                <img alt="example" style={{ width: '100%',  }} src={previewImage}  />
            </Modal>
        </>
    );
};

export default UploadImages;